<template>
    <div>
        <b-form @submit="onSubmit"> 
        <b-row>
            <b-col cols="12" xl="4" class="my-1">            
                    <b-button @click="goToHome()" variant="transparent" size="sm" class="pull-left">
                        <font-awesome-icon icon="angle-left" size="2x" />
                    </b-button>
                    <h3 class="text-themecolor my-1">Trigger {{$route.params.triggerId}} <span v-if="this.isForCopy">{{$t('buttons.kopieren')}}</span></h3>            
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7"  label="Naam" label-for="input-horizontal">
                    <b-form-input ref="name" :key="readCommand.naam" id="input-horizontal" v-model="command.naam" @onChange='command["naam"]=$event'></b-form-input>
                </b-form-group>
                <b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7" label="Fablet" label-for="input-horizontal">
                    <MatchRegex ref="fablet" :key="readCommand.keywords" :regex="command.keywords" :testcontent="trigger.testcontent" @onChange='command["keywords"]=$event; getFabletResult($event, trigger.testcontent)' :isForFablet="true" style="margin-left: 0px" />                  
                </b-form-group>     
                <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7">
                    <!--When more Modifiers change above to '<b-form-group label="Modifers">' and remove the label class 'pull-left'-->
                   <b-form-checkbox id="checkbox-1" name="checkbox-1" class="pull-left">Credit</b-form-checkbox>
                </b-form-group> 

                <h2>Kopgegevens </h2>

                <b-form-group label="Factuurnummer" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="factuurnummer" :key="readCommand.factuurnummer" :regex="command.factuurnummer" :testcontent="trigger.testcontent" @onChange='command["factuurnummer"]=$event' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.factuurnummer" :regexFieldType="regexFieldTypeEnum.Numberic"/>
                </b-form-group>
                <b-form-group label="Factuurdatum" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="factuurdatum" :key="readCommand.factuurdatum" :regex="command.factuurdatum" :testcontent="trigger.testcontent" @onChange='command["factuurdatum"]=$event' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.factuurdatum" :regexFieldType="regexFieldTypeEnum.Date" />
                </b-form-group>

                <b-form-group label="Referentie" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="referentie" :key="readCommand.referentie" :currentId="command.id" :regex="command.referentie" :testcontent="trigger.testcontent" :showRegexField=false @onChange='command["referentie"]=$event' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" />
                </b-form-group>

                <h2>Bedragen</h2>
                <b-form-group label="Totaalbedrag" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="totaalbedrag" :key="readCommand.totaalbedrag"  :regex="command.totaalbedrag" :testcontent="trigger.testcontent" @onChange='command["totaalbedrag"]=$event' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.totaalbedrag" />
                </b-form-group>
                <b-form-group label="Subtotaal" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="subtotaal" :key="readCommand.subtotaal"   :regex="command.subtotaal" :testcontent="trigger.testcontent" @onChange='command["subtotaal"]=$event' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.subtotaal" />
                </b-form-group>

                <b-form-group label="BTW laag" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="btwLaag"  :key="readCommand.btwLaag" :regex="command.btwLaag" :testcontent="trigger.testcontent" @onChange='setBtwLaag($event)' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.btwLaag" />
                </b-form-group>
                <b-form-group label="BTW hoog" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="btwHoog"  :key="readCommand.btwHoog" :regex="command.btwHoog" :testcontent="trigger.testcontent" @onChange='setBtwHoog($event)' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.btwHoog" />
                </b-form-group>

                <b-form-group label="Kosten nul" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="kostenNul" :key="readCommand.kostenNul" :regex="command.kostenNul" :testcontent="trigger.testcontent" @onChange='command["kostenNul"]=$event' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.kostenNul" />
                </b-form-group>

                <b-form-group label="Kosten verlegd" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="kostenVerlegd"  :key="readCommand.kostenVerlegd" :regex="command.kostenVerlegd" :testcontent="trigger.testcontent" @onChange='command["kostenVerlegd"]=$event' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.kostenVerlegd" />
                </b-form-group>

                <b-form-group label="Kosten laag" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="kostenLaag" :key="readCommand.kostenLaag" :regex="command.kostenLaag" :testcontent="trigger.testcontent" @onChange='command["kostenLaag"]=$event' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.kostenLaag" />
                </b-form-group>

                <b-form-group label="Kosten hoog" label-for="input-formatter" class="mb-0" >
                    <MatchRegex ref="kostenHoog"  :key="readCommand.kostenHoog" :regex="command.kostenHoog" :testcontent="trigger.testcontent" @onChange='command["kostenHoog"]=$event' @resultRegex='onHandleRegexResult($event)' class="no-margin-left" :dropdown=true :options="options.kostenHoog" />
                </b-form-group>
                <b-button id="btn-save-trigger" size="sm" type="submit"  variant="themecolor" >{{$t('buttons.opslaan')}}</b-button>                      
            </b-col>
            <b-col md="4" class="my-1 nopadding" >
                <text-highlight :queries="regexResult" class="textarea-text">{{ trigger.testcontent }}</text-highlight>                 
            </b-col>
            <b-col md="4" class="my-1 nopadding">            
                    <div v-if="!isImageLoaded">
                        <PreLoader/>
                    </div>
                    <b-card-text v-if="isImageLoaded"> <v-zoomer><img :src="'data:image/jpeg;base64,'+ image" class="w-100 h-100" /></v-zoomer></b-card-text>        
            </b-col>
        </b-row>
        </b-form>
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import Command from './command'
import MatchRegex from '@/components/fmmanagement/MatchRegex.vue'
import PreLoader from '@/components/root/Preloader';
import TextHighlight from 'vue-text-highlight';
import { fabletMixin } from '@/mixins/fabletMixin';
import RegexFieldTypeEnum from "@/enums/modules/RegexFieldType";

export default {
    name: 'triggers-detail',
    components: {MatchRegex,PreLoader, TextHighlight},
    mixins: [fabletMixin],
    data() {
        return {
            readCommand: new Command(),
            command: new Command(),
            renderKostenLaag: true,
            renderKostenHoog: true,
            options: { factuurnummer: [], factuurdatum: [], totaalbedrag: [], subtotaal: [], btwLaag: [], btwHoog: [], kostenNul: [], kostenVerlegd: [], kostenLaag: [], kostenHoog:[]},
            isImageLoaded: false,
            isForCopy: false,
            regexResult: '',
            regexFieldTypeEnum: RegexFieldTypeEnum
        }
    },
    computed: {
        ...mapGetters('fmmodule',['trigger','triggers']),
        ...mapGetters('errors', ['statusCode', 'notFoundError'])
    },
    methods: {
        ...mapActions('fmmodule',['find','create','update','executeCommand','errors','getImage']),
        goToHome()
        {
            this.$router.push({ name: `triggers:index`});      
        },
        onSubmit(event) {
            event.preventDefault();
            var vm = this;
            var payload = {
                resource: 'triggers',
                params: vm.command
            };
            if(this.isForCopy){
                vm.command.id = 0;
                vm.create(payload)
                .then(()=> {
                    vm.$router.push({ name: `triggers:index` });
                });
            }
            else{
                vm.update(payload)
                .then(()=> {
                    vm.$router.push({ name: `triggers:index` });
                });
            }

        },
        loadImage()
        {
            var vm = this;
            vm.$store.dispatch('errors/clearErrors');
            vm.getImage(
                {
                    resource:"images",
                    filename: vm.trigger.testfilename
                }
                ).then((response) => {
                    this.isImageLoaded = true
                    this.image = response;
                }  )
        }, 
        onHandleRegexResult(regexResult){
            this.regexResult = regexResult;
        },   
        getFabletResult(fablet, content) {
            this.regexResult = fabletMixin.getMusthaveKeywords(fablet, content);
        },
        async setBtwLaag(event) {
            if (this.command["btwLaag"] === event) {
                return
            }

            this.command["btwLaag"] = event

            if (event === "") {
                return
            }

            if (this.command["kostenLaag"] == undefined || this.command["kostenLaag"] == null || this.command["kostenLaag"] === '' )
            {
                this.renderKostenLaag = false

                this.command["kostenLaag"] = this.command["subtotaal"]
                this.readCommand["kostenLaag"] = this.command["subtotaal"]

                await this.$nextTick();
                this.renderKostenLaag = true                
            }
        },
        async setBtwHoog(event) {
            if (this.command["btwHoog"] === event) {
                return
            }

            this.command["btwHoog"] = event

            if (event === "") {
                return
            }

            if (this.command["kostenHoog"] == undefined || this.command["kostenHoog"] == null || this.command["kostenHoog"] === '' )
            {
                this.renderKostenHoog = false

                this.command["kostenHoog"] = this.command["subtotaal"]
                this.readCommand["kostenHoog"] = this.command["subtotaal"]

                await this.$nextTick();
                this.renderKostenHoog = true
            }
        },        
        async GetDropdownItems(column)
        {
            var vm = this;
            await vm.executeCommand({resource: 'triggers/getTopFive?column=' + column})
                     .then((data) => {                   
                        this.options[column] = data.split("|||")
                    }).catch(() => {
                        vm.$swal("Er is iets verkeerd gegaan bij ophalen DropDown items, probeer het opnieuw");
                    });
        }
    },
    created() {
        this.isForCopy = this.$route.params.copyTrigger
        var vm = this;
        vm.find({
            resource: 'triggers',
            id: this.$route.params.triggerId
        })
        .then(() => {
            this.loadImage();
               
            vm.command = new Command(vm.trigger)
            vm.readCommand = new Command(vm.trigger)

            this.GetDropdownItems('factuurnummer')
            this.GetDropdownItems('factuurdatum')
            this.GetDropdownItems('totaalbedrag')
            this.GetDropdownItems('subtotaal')
            this.GetDropdownItems('btwLaag')
            this.GetDropdownItems('btwHoog')
            this.GetDropdownItems('kostenNul')
            this.GetDropdownItems('kostenVerlegd')
            this.GetDropdownItems('kostenLaag')
            this.GetDropdownItems('kostenHoog')

        })
    }
}
</script>
<style>
.textarea-text{
        white-space: pre-line;
    } 
</style>